// Per-item human review marks for pipeline steps (seen / approved). These are
// reviewer-local bookkeeping, deliberately kept in localStorage rather than the
// DB — see the ingestion progress-bar requirements.

const storageKey = (itemId) => `ingestion-step-review:${itemId}`;

/** @returns {{ [step: number]: { seen?: boolean, approved?: boolean } }} */
export const loadStepReview = (itemId) => {
    try {
        return JSON.parse(window.localStorage.getItem(storageKey(itemId))) || {};
    } catch {
        return {};
    }
};

export const saveStepReview = (itemId, review) => {
    try {
        window.localStorage.setItem(storageKey(itemId), JSON.stringify(review));
    } catch {
        /* private mode / quota — review marks are best-effort */
    }
};
